module.exports = __webpack_public_path__ + "static/media/maybernBg.b2ceef94.png";